<template>
  <v-row>
    <v-col cols="12" offset-lg="1" lg="10">
      <v-breadcrumbs :items="breadcrumbs" divider=">" class="pl-1 pb-3" />
      <v-card>
        <v-card-title class="theme">
          <v-icon class="white--text">volume_up</v-icon>
          <span class="headline ml-2 white--text">Announcements</span>
          <v-spacer />
          <v-btn
            @click="add"
            depressed
            v-if="validRole"
            class="action white--text rounded-sm"
            >Add
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            v-if="announcements"
            :items="announcements"
            hide-default-footer
            :headers="tableHeaders"
            class="px-2 mt-0 pt-0 row-pointer"
            @click:row="showDetails"
          >
            <template v-slot:footer>
              <div class="py-1" v-if="tableHeaders">
                <div class="text-center">
                  <v-btn
                    fab
                    small
                    class="theme"
                    depressed
                    @click="previous"
                    :disabled="pagination.page <= 0"
                  >
                    <v-icon small>navigate_before</v-icon>
                  </v-btn>
                  <span>
                    <v-btn text :disabled="true">{{
                      pagination.page + 1
                    }}</v-btn>
                  </span>
                  <v-btn
                    fab
                    small
                    depressed
                    class="theme"
                    @click="next"
                    :disabled="pagination.disableNext"
                  >
                    <v-icon small>navigate_next</v-icon>
                  </v-btn>
                </div>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
    <!--    <v-col cols="12" lg="3" class="pl-1">-->
    <!--      <v-card flat class="mt-14">-->
    <!--        <v-card-title>-->
    <!--          <span class="title font-weight-regular grey&#45;&#45;text text&#45;&#45;darken-2">Manage company announcements</span>-->
    <!--        </v-card-title>-->
    <!--        <v-card-text class="pt-0">-->
    <!--          <span class="subheading"></span>-->
    <!--          <div class="grey&#45;&#45;text text&#45;&#45;darken-1 mt-1">-->
    <!--            Announcements are used to convey company wide information to the employees For e.g. Changing office locations or replacing company wide insurance plan.-->
    <!--            Use this section to manage announcements.-->
    <!--          </div>-->
    <!--        </v-card-text>-->
    <!--        <v-card-actions>-->
    <!--          <v-btn depressed class="action white&#45;&#45;text rounded-sm ml-2 mb-3" @click="add">Add</v-btn>-->
    <!--        </v-card-actions>-->
    <!--      </v-card>-->
    <!--    </v-col>-->

    <v-snackbar v-model="snackbar" :bottom="true" :right="true">
      {{ snackbarMessage }}
      <v-btn color="pink" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-row>
</template>

<script>
import {mapGetters} from "vuex";

import {Actions} from "@/views/actions";
import {Breadcrumbs} from "@/views/breadcrumbs";
import {Component} from "@/views/component";
import {Constants} from "@/views/constants";
import {TableHeaders} from "@/views/headers";

export default {
  name: Component.Protected.Announcement.List,
  computed: {
    ...mapGetters(["userInfo", "announcements"]),
  },
  data: () => ({
    breadcrumbs: Breadcrumbs.Announcement.List,
    tableHeaders: TableHeaders.Announcement.List,
    search: {limit: 10, offset: 0},
    pagination: { disableNext: true, page: 0 },
  }),
  methods: {
    next() {
      if (this.pagination.page < 0) {
        this.pagination.page = 0;
        this.search.offset = 0;
      } else if (this.announcements.length < this.search.limit) {
        this.pagination.disableNext = false;
        this.pagination.page++;
        this.search.offset = this.search.limit * this.pagination.page;
        this.list();
      }
    },
    previous() {
      this.pagination.page--;
      if (this.pagination.page < 0) {
        this.pagination.page = 0;
        this.search.offset = 0;
      } else {
        this.pagination.disableNext = false;
        this.search.offset = this.search.limit * this.pagination.page;
        this.list();
      }
    },
    add() {
      this.$router.push({ name: Component.Protected.Announcement.Add });
    },
    list() {
      this.$store
        .dispatch(Actions.Announcement.Find, this.search)
        .then(() => {
          let len = this.announcements.length;
          if ((len < this.search.limit && len > 0) || len === 0) {
            this.pagination.disableNext = true;
          } else if (len === this.search.limit) {
            this.pagination.disableNext = false;
          }
        })
        .catch((err) => {
          console.error(Constants.Announcement.Messages.Error.Find, err);
          this.snackbar = true;
          this.snackbarMessage = Constants.Announcement.Messages.Error.Find;
        });
    },
    showDetails(item) {
      if (!item || !item.id) return false;
      if (this.userInfo.role === Constants.Roles.HR || this.userInfo.role === Constants.Roles.Manager) {
        this.$router.push({
          name: Component.Protected.Announcement.Edit,
          params: {id: item.id},
        });
      } else {
        this.$router.push({
          name: Component.Protected.Announcement.Read,
          params: {id: item.id},
        });
      }
    },
    validRole() {
      return this.userInfo.role === Constants.Roles.Manager ||
          this.userInfo.role === Constants.Roles.HR;
    }
  },
  created() {
    if (this.userInfo) {
      this.list();
    } else {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.list());
    }
  },
};
</script>